<script lang="ts">
    import {
        COMMON__Unlike,
        FAVORITE__View_my_favorite_translations,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { getGlosbeTransferState } from "@app/services/transferState-service";
    import Menu from "../Menu.svelte";
    import {
        favoriteTranslations,
        removeTranslationFromFavoritesFromCurrentDictionary,
    } from "./FlashcardsIntegration.service";

    export let marker: HTMLButtonElement;
    export let phrase: string;
    let isFavorite = false;
    let isMenuOpen = false;
    const IS_FAVORITE_MARKER_CLASS = "is-favorite";
    const glosbeTransferState = getGlosbeTransferState();

    function updateMarkerStatus() {
        if (isFavorite) {
            marker.classList.add(IS_FAVORITE_MARKER_CLASS);
            marker.dataset["isInFavorites"] = "true";
        } else {
            marker.classList.remove(IS_FAVORITE_MARKER_CLASS);
            delete marker.dataset["isInFavorites"];
        }
    }

    favoriteTranslations.subscribe((favoriteTranslationsData) => {
        const newIsFavorite =
            favoriteTranslationsData.find(
                (translation) => translation.phrase === phrase
            )?.favorite ?? false;

        if (newIsFavorite !== isFavorite) {
            isFavorite = newIsFavorite;
            updateMarkerStatus();
        }
    });

    function onContextMenuClose() {
        isMenuOpen = false;
    }

    marker.onclick = (event: Event) => {
        if (isFavorite) {
            removeTranslationFromFavoritesFromCurrentDictionary(phrase);
            /*    setTimeout(() => {
                if (!isMenuOpen) {
                    isMenuOpen = true;
                    return false;
                }
            });*/
        }
    };

    function onRemoveFromFavorites(event: Event) {
        removeTranslationFromFavoritesFromCurrentDictionary(phrase);
    }
</script>

<Menu open={isMenuOpen} onClose={onContextMenuClose} activator={marker}>
    <li>
        <a
            href={`/user/favoriteTranslations?l1=${glosbeTransferState.dictionary.l1.code}&l2=${glosbeTransferState.dictionary.l2.code}`}
            class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700"
        >
            {getMessage(FAVORITE__View_my_favorite_translations)}
        </a>
    </li>
    <li>
        <button
            class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700"
            on:click={onRemoveFromFavorites}
        >
            {getMessage(COMMON__Unlike)}
        </button>
    </li>
</Menu>
